// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debug = (message: any, ...rest: Array<any>): void => {
    if (process.env.NEXT_PUBLIC_DEPLOY_ENV !== "production") {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, no-console
        console.log(message, ...rest);
    }
};
